import React from 'react';
import './Spinner.css';
import {useSelector} from "react-redux";
import users from "../../users";

function Spinner({className = ""}) {

    const darkMode = useSelector(users.selectors.isDarkMode);

    return (
        <div className={"Spinner d-flex flex-column align-items-center justify-content-center" + className}>
            <div className={"Spinner__dot1 " + (darkMode ? "background-white" : "background-dark")}></div>
            <div className={"Spinner__dot2 " + (darkMode ? "background-white" : "background-dark")}></div>
        </div>
    );
}

export default Spinner;
